var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoAnalyseSansTexte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43.364,
    height: 43.364,
    viewBox: "-0.193 -1.682 43.364 43.364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 40.375,
    height: 40,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "picto_analyse",
    "data-name": "picto analyse",
    transform: "translate(70 0.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "picto_analyse-2",
    "data-name": "picto analyse",
    transform: "translate(-68.704 -0.023)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_97",
    "data-name": "Trac\\xE9 97",
    d: "M8.1,40.418A8.089,8.089,0,0,1,1.64,27.461L17.526,6.384l.746.563L2.387,28.022A7.155,7.155,0,0,0,13.76,36.7L30.208,15.43l.739.571L14.5,37.276a8.109,8.109,0,0,1-5.71,3.113c-.229.019-.457.029-.685.029",
    transform: "translate(0 -0.418)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_98",
    "data-name": "Trac\\xE9 98",
    d: "M32.857,15.83a8.273,8.273,0,0,1-1.821-.226,19.331,19.331,0,0,1-6.462-3.064c-4.682-3.276-7.236-7.434-5.813-9.466.72-1.032,2.293-1.333,4.423-.848a19.339,19.339,0,0,1,6.463,3.063,19.333,19.333,0,0,1,5.093,5.02c1.187,1.834,1.442,3.415.72,4.445a3,3,0,0,1-2.6,1.076m-11.5-12.9a2.135,2.135,0,0,0-1.828.677c-.946,1.352,1.115,5.038,5.585,8.165a18.345,18.345,0,0,0,6.133,2.918c1.709.39,2.967.218,3.45-.472s.213-1.931-.739-3.4a18.341,18.341,0,0,0-4.844-4.76,18.344,18.344,0,0,0-6.134-2.919,7.381,7.381,0,0,0-1.622-.2",
    transform: "translate(-1.203 -0.131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_99",
    "data-name": "Trac\\xE9 99",
    d: "M34.857,13.83a8.273,8.273,0,0,1-1.821-.226,19.331,19.331,0,0,1-6.462-3.064c-4.682-3.276-7.236-7.434-5.813-9.466C21.482.042,23.054-.259,25.183.226a19.339,19.339,0,0,1,6.463,3.063,19.333,19.333,0,0,1,5.093,5.02c1.187,1.834,1.442,3.415.72,4.445a3,3,0,0,1-2.6,1.076M23.354.933a2.135,2.135,0,0,0-1.828.677c-.946,1.352,1.115,5.038,5.585,8.165a18.345,18.345,0,0,0,6.133,2.918c1.71.39,2.967.218,3.45-.472s.213-1.931-.739-3.4a18.341,18.341,0,0,0-4.844-4.76,18.344,18.344,0,0,0-6.134-2.919,7.381,7.381,0,0,0-1.622-.2",
    transform: "translate(-1.334 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_100",
    "data-name": "Trac\\xE9 100",
    d: "M19.2,3.681a.467.467,0,0,1-.332-.8l1.9-1.919a.467.467,0,0,1,.664.657l-1.9,1.92a.466.466,0,0,1-.332.138",
    transform: "translate(-1.227 -0.054)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_101",
    "data-name": "Trac\\xE9 101",
    d: "M35.7,16.16a.467.467,0,0,1-.332-.8l1.9-1.919a.467.467,0,0,1,.664.657l-1.9,1.919a.466.466,0,0,1-.332.138",
    transform: "translate(-2.308 -0.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_102",
    "data-name": "Trac\\xE9 102",
    d: "M38.676,19.234l-3.122,5.151a3.575,3.575,0,0,0-.331.716l-.214.642a3.543,3.543,0,0,0,.264,2.839l.239.43a3.54,3.54,0,0,0,4.338,1.6l.315-.118a3.541,3.541,0,0,0,1.809-1.52l.193-.328a3.54,3.54,0,0,0,.287-2.974l-.311-.883a3.518,3.518,0,0,0-.364-.741Z",
    transform: "translate(-2.281 -1.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_103",
    "data-name": "Trac\\xE9 103",
    d: "M7.3,25.559,3.957,29.913a5.181,5.181,0,0,0,8.116,6.439L24.942,20.658S10.63,27.716,7.3,25.559",
    transform: "translate(-0.189 -1.353)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoAnalyseSansTexte);
export default __webpack_public_path__ + "static/media/picto_analyse_sans_texte.f6c5322dbbf70740f778b919dbd71fa2.svg";
export { ForwardRef as ReactComponent };